import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "@/components/common/Logo";
import { Button } from "@/components/ui/button";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="p-6 border-b border-gray-100">
        <Logo size="lg" />
      </header>

      <main className="flex-1 flex flex-col justify-center items-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl text-center space-y-6"
        >
          <h1 className="text-4xl font-bold text-darkBlue-DEFAULT">
            CleoMed Livreur
          </h1>
          <p className="text-lg text-gray-600">
            Application de livraison pour les pharmaciens partenaires CleoMed.
          </p>
        </motion.div>
      </main>

      <footer className="p-6 text-center text-gray-400 text-sm">
        © {new Date().getFullYear()} CleoMed. Tous droits réservés.
      </footer>
    </div>
  );
};

export default Index;
